// Essential to ensure Tailwind works correctly with our build
import '../css/main.css'

// CSS global imports
import '../css/global/buttons.css'
import '../css/global/global.css'
import '../css/global/inputs.css'

// CSS component imports
import '../css/components/article.css'
import '../css/components/cart.css'
import '../css/components/collection.css'
import '../css/components/featured-grid.css'
import '../css/components/header.css'
import '../css/components/product-carousel.css'
import '../css/components/product-template.css'
import '../css/components/shopify-challenge.css'


// JS Components
import './components/animate-image-on-scroll'
import './components/content-padding'
import './components/fullheight-containers'
import './components/featured-grid-carousel'
import './components/homepage-masthead-carousel'
import './components/products-carousel'
import './components/split-scroll'


// AlpineJS
import Alpine from 'alpinejs'
window.Alpine = Alpine

// Alpine Plugins
import collapse from '@alpinejs/collapse'
Alpine.plugin(collapse)

//Alpine Store
import './store'

// Alpine Directives
import { money, imageTransform } from './directives'
Alpine.directive('money', money)
Alpine.directive('image-transform', imageTransform)

// Alpine Components
import customerAddresses from './components/customer-addresses'
import header from './components/header'
import product from './components/product'
import splitScroll from './components/split-scroll'
Alpine.data('customerAddresses', customerAddresses)
Alpine.data('header', header)
Alpine.data('product', product)
Alpine.data('splitScroll', splitScroll)

Alpine.start()
